module.exports = __webpack_public_path__ + "img/uwe_schill.0c5cc417.jpeg";